<template>
  <div class="tab-pane active">
    <div class="row justify-content-center">
      <div class="col-md-10 col-lg-8">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProfileInvited"
  }
</script>

<style scoped>

</style>
